import { getCssPackPath } from '@/libs/tinymce/utils/index'

// основные настройки
// используются, когда нужны картинки, цитаты, таблицы
// обязательно нужно указать путь для загрузки картинки!

export const mainCfgWithImgSettings = {
  body_class: 'infoItemContent',
  content_css: getCssPackPath(),
  height: 300,
  plugins: 'code,image,link,lists,table',
  style_formats: [
    { title: 'p', block: 'p', classes: false },
    { title: 'div', block: 'div', classes: false },
    { title: 'Подзаголовок 1', block: 'h2'},
    {
      items: [
        { title: 'Заголовок', block: 'div', classes: 'incut__caption' },
        { title: 'Текст', block: 'div', classes: 'incut', wrapper: true},
      ],
      title: 'Врезка',
    },
    { title: 'Подпись к фото', block: 'div', classes: 'picture__caption'},
    {
      items: [
        { title: 'Цитата', block: 'blockquote', wrapper: true },
        { title: 'Автор', block: 'div', classes: 'quote__author' },
        { title: 'Должность', block: 'div', classes: 'quote__about' },
        { title: 'Текст', block: 'div', classes: 'quote__text' },
      ],
      title: 'Цитата',
    },
    {
      items: [
        { title: 'Слева', block: 'div', classes: 'picture__left'  },
        { title: 'Справа', block: 'div', classes: 'picture__right' },
        { title: 'По центру', block: 'div', classes: 'picture__center' },
      ],
      title: 'Выравнивание картинки',
    },
  ],
  toolbar: [
    `styleselect | fontsizeselect bold italic underline | bullist numlist outdent indent blockquote | undo redo
    | link | image | alignleft aligncenter alignright alignjustify | code | table`,
  ],
}
